export const LOCAL_STORAGE_KEYS = {
  SELECTED_BARGE: 'SELECTED_BARGE',
  THEME: 'THEME',
} as const; 